module.exports = {
	"map_center": [
		30.26618,
		-97.74467
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./config.json
 ** module id = 1
 ** module chunks = 0 1 2 3
 **/